module.exports = __webpack_public_path__ + "img/2V.2.9ccfeb40.jpg";